import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getWorkSpace, loginUser } from '../../../redux/MainAction';
import Axios from 'axios';
import Constant from '../../../Constant';
import { toast } from 'react-toastify';
import { getDomainType } from '../../../Constant';

const Login = () => {
  const dispatch = useDispatch();
  const space = useSelector((state) => state?.Webtracker?.workspace);

  const [userRole, setUserRole] = useState('user');

  const [ownerId, setOwnerID] = useState('');

  const employees = localStorage.getItem('employee');

  const [login, setLogin] = useState({
    email: '',
    password: '',
  });
  const onHandleChange = (e) => {
    const { value, name } = e.target;
    setLogin({ ...login, [name]: value });
  };

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    if (employees) {
      dispatch(getWorkSpace());
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const data1 = {
      domainName: getDomainType(),
    };

    try {
      if (userRole === 'domain') {
        const loginData = {
          email: login.email,
          password: login.password,
        };

        dispatch(loginUser(loginData, 'domain'));
      } else if (userRole === 'employeeWeb') {
        const response = await Axios.post(
          Constant.getAPI() + `${userRole}/auth/domain/get`,
          data1,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response?.data?.data && response?.data?.data?.id) {
          const domainId = response.data.data.id;

          const loginData = {
            domainId: response.data.data.id,
            email: login.email,
            password: login.password,
          };

          dispatch(loginUser(loginData, userRole));
          // setIsEmployee(true)
        } else {
          alert('Invalid domain response.');
        }
      } else {
        const response = await Axios.post(
          Constant.getAPI() + `${userRole}/auth/domain/get`,
          data1,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response?.data?.data && response?.data?.data?.id) {
          const domainId = response.data.data.id;

          const loginData = {
            domainId: response.data.data.id,
            email: login.email,
            password: login.password,
          };

          dispatch(loginUser(loginData, userRole));
        } else {
          alert('Invalid domain response.');
        }
      }
    } catch (error) {
      console.error(
        'Error submitting domain:',
        error.response ? error.response.data : error.message
      );
      alert('Failed to submit the domain.');
    }
  };

  const onSubmitWorkspace = (e) => {
    e.preventDefault();
    if (ownerId === '') {
      toast.error('Please Select Workspace', {
        position: 'top-right',
      });
      return false;
    }

    localStorage.setItem('ownerId', ownerId);
    localStorage.setItem('loged_In', true);

    window.location.reload();
  };

  return (
    <AUX>
      <div
        className="accountbg"
        style={{
          background: "url('assets/images/stardust.png')",
          backgroundSize: 'cover',
        }}
      ></div>
      <div className="wrapper-page">
        <div className="card">
          <div className="card-body">
            <h3 className="text-center m-0">
              <Link to="/" className="logo logo-admin">
                <img src="/assets/images/logo.webp" height="30" alt="logo" />
              </Link>
            </h3>

            <div className="p-3">
              <h4 className="font-18 m-b-5 text-center">Welcome Back !</h4>
              <p className="text-muted text-center">
                Sign in to continue to Web Tracker
              </p>

              {employees ? (
                <form className="form-horizontal m-t-30" action="/">
                  <div className="form-group">
                    <label for="work">Select Workspace</label>
                    <select
                      className="form-control"
                      id="work"
                      value={ownerId}
                      onChange={(e) => setOwnerID(e.target.value)}
                    >
                      <option value="">Select Workspace</option>
                      {space?.rows?.map((spc, idx) => (
                        <option key={idx} value={spc?.ownerId}>
                          {spc?.workspaceName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mt-4">
                    <button
                      onClick={onSubmitWorkspace}
                      className="btn btn-primary w-md waves-effect waves-light w-100"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              ) : (
                <form className="form-horizontal m-t-30" action="/">
                  <div className="form-group">
                    <label for="username">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={login.email}
                      onChange={onHandleChange}
                      className="form-control"
                      id="username"
                      placeholder="Enter email"
                    />
                  </div>

                  <div className="form-group">
                    <label for="userpassword">Password</label>
                    <input
                      type="password"
                      name="password"
                      value={login.password}
                      onChange={onHandleChange}
                      className="form-control"
                      id="userpassword"
                      placeholder="Enter password"
                    />
                  </div>

                  <div className="form-group">
                    <label for="roleType">Select Role</label>
                    <select
                      className="form-control"
                      id="roleType"
                      value={userRole}
                      onChange={(e) => setUserRole(e.target.value)}
                    >
                      <option value="user">Admin</option>
                      <option value="domain">Super Admin</option>
                      <option value="employeeWeb">Employee</option>
                    </select>
                  </div>

                  <div className="mt-4">
                    <button
                      onClick={onSubmit}
                      className="btn btn-primary w-md waves-effect waves-light w-100"
                      type="submit"
                    >
                      Log In
                    </button>
                  </div>

                  <div className="d-flex justify-content-between">
                    {userRole === 'user' || userRole === 'employeeWeb' ? (
                      <p className="mt-2 font-14">
                        <Link
                          to="/forgot-password"
                          className="font-500 font-secondary"
                        >
                          Forgot Password?
                        </Link>
                      </p>
                    ) : null}

                    {userRole === 'user' ? (
                      <p className="mt-2 font-14">
                        <Link to="/sign-up" className="font-500 font-secondary">
                          Signup
                        </Link>
                      </p>
                    ) : null}
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>

        <div className="m-t-20 text-center">
          <p className="text-white">
            © {new Date().getFullYear() - 1} - {new Date().getFullYear()} Web
            Tracker
          </p>
        </div>
      </div>
    </AUX>
  );
};

export default Login;
